export default __webpack_public_path__ + "static/media/SignInSignUpDesign.a000cff6.gif";